<template>
  <v-list class="sf-nav"
          nav>

    <v-list-item exact
                 v-bind:to="{ name: 'home' }">
      <v-list-item-icon>
        <v-icon>ti-home</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('home') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'registration-supplier-design', params: { invitationCode: invitationCode } }">
      <v-list-item-icon>
        <v-icon>ti-palette</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('design') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-bind:to="{ name: 'supplier-orders', params: { invitationCode: invitationCode } }"
                 v-if="isLive">
      <v-list-item-icon>
        <v-icon>ti-clipboard-list</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('orders') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      invitationCode: null
    }),
    created() {
      this.invitationCode = this.$route.params.invitationCode
    },
    computed: {
      ...mapGetters([
        'currentCustomer',
        'isLive'
      ])
    },
    name: 'PrimaryNavigation'
  }
</script>

<i18n>
  {
    "de": {
      "menu": "Menü",
      "help": "Hilfe",
      "home": "Startseite",
      "legal": "Impressum",
      "privacyPolicy": "Datenschutzerklärung",
      "newArrivals": "Neuheiten",
      "products": "Produkte",
      "myOrders": "Meine Bestellungen",
      "design": "Design",
      "orders": "Bestellungen"
    },
    "en": {
      "menu": "Menu",
      "help": "Help",
      "home": "Home",
      "legal": "Legal",
      "privacyPolicy": "Privacy policy",
      "newArrivals": "New arrivals",
      "products": "Products",
      "myOrders": "My orders",
      "design": "Design",
      "orders": "Orders"
    }
  }
</i18n>
